import type { SectionKind, ViewModeConfig } from '@/lib/song';
import { cn } from '@/lib/utils';

export const sectionColor = (kind: SectionKind) => `var(--section-${kind})`;

/** Rótulo de seção, em 3 variantes conforme o modo de visualização. */
export const SectionLabel: React.FC<{
  name: string;
  kind: SectionKind;
  variant: ViewModeConfig['sectionLabel'];
  className?: string;
}> = ({ name, kind, variant, className }) => {
  const color = sectionColor(kind);

  if (variant === 'pill') {
    return (
      <span
        className={cn(
          'inline-flex w-fit items-center rounded-full border px-2.5 py-0.5 font-bold text-[10.5px] uppercase tracking-[0.12em]',
          className,
        )}
        style={{ color, borderColor: color }}
      >
        {name}
      </span>
    );
  }

  if (variant === 'dot-display') {
    return (
      <span className={cn('flex items-center gap-2.5', className)} style={{ color }}>
        <span className="size-2 rounded-full" style={{ background: color }} />
        <span className="font-bold font-display text-[18px] normal-case">{name}</span>
      </span>
    );
  }

  return (
    <span className={cn('flex items-center gap-2.5', className)} style={{ color }}>
      <span className="size-1.5 rounded-full" style={{ background: color }} />
      <span className="font-bold text-[11px] uppercase tracking-[0.12em]">{name}</span>
      <span className="h-px flex-1 opacity-25" style={{ background: color }} />
    </span>
  );
};
